import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
    timeout: boolean

}
const initialState: InitialState = {
    timeout: false

};
const IdleTimeout_slice = createSlice({
    name: "IdleTimeout",
    initialState,
    reducers: {
        setIdleTimeout(state, action: PayloadAction<{ timeout: boolean }>) {
            state.timeout = action.payload.timeout;
        },
    },
});

export const { setIdleTimeout } = IdleTimeout_slice.actions;
export default IdleTimeout_slice.reducer;